import React from 'react';
import AppointmentWithContactInfoSection from '../Section/AppointmentWithContactInfoSection';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';
import '../../sass/shortcode/Appointments.scss';

export default function Appointments() {
  pageTitle('Appointments');
  return (
    <>
      <section className="cs_appt_banner">
        <span className="cs_appt_dots" />
        <div className="container">
          <div className="cs_appt_banner_row">
            <div className="cs_appt_banner_left">
              <h1>Don’t Let Your Health Take a Backseat!</h1>
              <span className="cs_appt_underline" />
              <p>
                Fill out the appointment form below to schedule a
                consultation with one of our healthcare professionals.
              </p>
            </div>
            <div className="cs_appt_banner_right">
              <img
                src="/images/appointments/banner_stethoscope_heart.png"
                alt="Book an appointment"
              />
            </div>
          </div>
        </div>
      </section>
      <Section
        topMd={20}
        topLg={50}
        topXl={40}
        bottomMd={60}
        bottomLg={20}
        bottomXl={10}
      >
        <AppointmentWithContactInfoSection />
      </Section>
    </>
  );
}
